import { t } from 'i18next';
import type { I18nPrefix } from '../../../../i18n/prefix';

const COMPONENT = 'features:home.components.onboarding.badges' satisfies I18nPrefix;

/** The "Completed"/"Pending" pill each accordion row's title carries. */
export function onboardingStepBadge(complete: boolean) {
  return {
    text: t(complete ? `${COMPONENT}.complete` : `${COMPONENT}.pending`),
    variant: complete ? ('green' as const) : ('default' as const),
  };
}
